export default {"src":"/_next/static/media/farmhouse-bungalows-icon.e99588b2.svg","height":74,"width":134,"blurWidth":0,"blurHeight":0};